import { useLocalStorage, writeStorage } from '@rehooks/local-storage'
import { useCallback, useMemo } from 'react'

import { LocalStorageKeys } from '../../../enums/localStorageKeys'
import { parseHiddenColumnIds } from '../constants/expertTrialBalanceColumnIds'
import type { ExpertTrialBalanceColumnId } from './useExpertTrialBalanceColumns'

interface ExpertTrialBalanceHiddenColumns {
  hiddenColumns: ExpertTrialBalanceColumnId[]
  setHiddenColumns: (hiddenColumnIds: ExpertTrialBalanceColumnId[]) => void
}

export const useExpertTrialBalanceHiddenColumns = (): ExpertTrialBalanceHiddenColumns => {
  const [storedHiddenColumns] = useLocalStorage<unknown>(LocalStorageKeys.ExpertTrialBalanceHiddenColumns)

  const hiddenColumns = useMemo(() => parseHiddenColumnIds(storedHiddenColumns), [storedHiddenColumns])

  const setHiddenColumns = useCallback((hiddenColumnIds: ExpertTrialBalanceColumnId[]) => {
    writeStorage(LocalStorageKeys.ExpertTrialBalanceHiddenColumns, hiddenColumnIds)
  }, [])

  return { hiddenColumns, setHiddenColumns }
}
